(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eulique-collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.euk-grid').forEach((section) => {
    const track = section.querySelector('[data-euk-product-track]');
    if (!track) return;
    section.querySelectorAll('[data-euk-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = track.querySelector('.euk-card');
        if (!card) return;
        const distance = card.getBoundingClientRect().width + 18;
        const direction = button.dataset.eukScroll === 'prev' ? -1 : 1;
        track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eulique-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.euk-tabs').forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
          const panel = section.querySelector(`#${item.getAttribute('aria-controls')}`);
          if (panel) panel.hidden = !active;
        });
      });
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
        tabs[next].focus();
        tabs[next].click();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eulique-horse-media-album"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-eulique-horse-album]').forEach((album) => {
    const thumbs = album.querySelectorAll('[data-album-thumb]');
    const slides = album.querySelectorAll('[data-album-slide]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const selected = thumb.dataset.albumThumb;

        thumbs.forEach((item) => {
          const active = item.dataset.albumThumb === selected;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        slides.forEach((slide) => {
          const active = slide.dataset.albumSlide === selected;
          slide.classList.toggle('is-active', active);
          slide.hidden = !active;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eulique-lumaire-room-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-elr-slider]').forEach((slider) => {
    const range = slider.querySelector('[data-elr-range]');
    const after = slider.querySelector('[data-elr-after]');
    const handle = slider.querySelector('[data-elr-handle]');
    range.value = '50';
    const update = () => {
      const value = range.value;
      after.style.clipPath = `inset(0 0 0 ${value}%)`;
      handle.style.left = `${value}%`;
    };
    range.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eulique-signature-horse"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function(event) {
    var select = event.target.closest('[data-eulique-variant-select]');
    if (!select) return;
    var root = select.closest('.eulique-horse');
    var option = select.options[select.selectedIndex];
    var available = option.dataset.available === 'true';
    root.querySelector('[data-eulique-variant-input]').value = option.value;
    root.querySelectorAll('[data-eulique-price]').forEach(function(price) { price.textContent = option.dataset.price; });
    root.querySelectorAll('[data-eulique-submit]').forEach(function(button) {
      button.disabled = !available;
      var label = button.querySelector('[data-eulique-submit-label]');
      if (label) label.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
